import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
}
function FAQItem({
  question,
  answer
}: FAQItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-slate-200 last:border-0" data-id="element-25">
      <button className="flex w-full items-center justify-between py-4 text-left focus:outline-none" onClick={() => setIsOpen(!isOpen)} data-id="element-26">
        <span className="font-medium text-slate-900 pr-8" data-id="element-27">{question}</span>
        {isOpen ? <ChevronUp className="h-5 w-5 text-slate-500 flex-shrink-0" data-id="element-28" /> : <ChevronDown className="h-5 w-5 text-slate-500 flex-shrink-0" data-id="element-29" />}
      </button>
      {isOpen && <div className="pb-4 text-slate-600 leading-relaxed animate-in fade-in slide-in-from-top-2 duration-200" data-id="element-30">
          {answer}
        </div>}
    </div>;
}
export function FAQ() {
  const faqs = [{
    question: 'What kind of services does Brixen Credit provide?',
    answer: 'BRIXEN CREDIT LLC provides financial education and strategic consulting only. We teach you how credit and personal finances work so you can make informed decisions. We do not perform any actions on your accounts or reports on your behalf.'
  }, {
    question: 'Is this a credit repair service?',
    answer: 'No. We are not a credit repair organization as defined by the Credit Repair Organizations Act (CROA). We do not dispute items on your credit report, and we make no promises about outcomes. Our services are strictly limited to education, analysis, and strategic consulting.'
  }, {
    question: 'Do you guarantee any results?',
    answer: 'No. We do not guarantee credit score increases, approvals, or any specific financial outcomes. Results vary by individual financial profile. Our role is to educate and advise — any actions you choose to take are entirely your own.'
  }, {
    question: 'How does a consultation work?',
    answer: "You'll meet with a specialist who will educate you on how your credit profile works and provide a neutral, third-party perspective. We explain the principles and strategies so you can decide what to do with that knowledge."
  }, {
    question: 'Can you help me understand business credit?',
    answer: 'Yes. We offer educational consulting on business credit readiness, helping you understand how to separate personal and business finances and the principles of building a strong business credit foundation.'
  }];
  return <div className="max-w-3xl mx-auto" data-id="element-31">
      {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} data-id="element-32" />)}
    </div>;
}